import Vue from 'vue';
import Vuelidate from 'vuelidate';
const {
    required,
    minLength,
    maxLength,
    email,
    requiredIf
} = require('vuelidate/lib/validators');
import VueResource from 'vue-resource';
import DatePicker from '../components/components.date-picker.vue';
import Multiselect from 'vue-multiselect';

import {
    noForeignCharacters,
    goToFirstError,
    spinOpts,
    ApiUrls,
    ErrorCodes,
    RedirectsUrls,
    isUserLoggedIn,
    SessionKeys,
    setItemSessionStorage,
    getItemSessionStorage,
    deleteSessionStore,
    scrollToBlock,
    dateNotInPastSingleDate,
    singleDateValidation,
    convertoEnDate
} from '../helper-functions';

Vue.use(Vuelidate);
Vue.use(VueResource);
Vue.component('multiselect', Multiselect);

const AddTravelCompanion = {
    description: '',
    firstTimeTraveller: '',
    wheelchair: '',
    ticketBooked: '',
    autoMatchNotification: '',
    travelDate: '',
    toTravelDate: '',
    language1: '',
    language2: '',
    language3: '',
    language4: '',
    needHelpWithDTOs: [],
    needHelpWithOther: '',
    itineraryLegDTOs: [{
        fromAirportId: null,
        toAirportId: null,
        airlineId: null,
        itineraryOrder: 1
    }]
};

let addTCvalidation = {
    addTCform: {
        description: {
            required
        },
        firstTimeTraveller: {
            required
        },
        wheelchair: {
            required
        },
        ticketBooked: {
            required
        },
        autoMatchNotification: {
            required
        },
        travelDate: {
            required,
            dateNotInPastSingleDate,
            singleDateValidation
        },
        toTravelDate: {
            required: requiredIf(function (addTCform) {
                return this.addTCform.ticketBooked === 'No';
            }),
            dateNotInPastSingleDate,
            singleDateValidation,
            dateNotBeforeCreatedDate(val) {
                if (val) {
                    if (val) {
                        var dateToCheck1 = new Date(convertoEnDate(val));
                        var created = new Date(convertoEnDate(this.addTCform.travelDate));

                        return created <= dateToCheck1;
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            }
        },
        itineraryLegDTOs: {
            required,
            $each: {
                fromAirportId: {
                    required
                },
                toAirportId: {
                    required
                },
                airlineId: {
                    required: requiredIf(function (addTCform) {
                        return this.addTCform.ticketBooked !== 'No';
                    })
                }
            }
        }
    },
    languages: {
        required
    }
};

export let addTravelCompanion = {
    components: {
        'date-picker': DatePicker        
    },
    data () {
        return {
            addTCform: {...AddTravelCompanion},
            languages: [],
            needHelpWith: window.immiObj.listNeedHelp || [],
            selectedNeedHelp: {},
            isFormSubmitted: false,
            addPost: false,
            allLanguages: window.immiObj?.languages  || [],
            multiselectFocus: false,
            allAirports: [],
            allAirlines: [],
            dateRangePicker: {
                dateFormat: 'MM-DD-YYYY',
                singleDatePicker: true,
                autoApply: true,
                defaultRange: '',
                showDropdowns: true
            },
            noneSelected: false,
            addPostApiInProgress: false,
            addPostSuccess: false,
            addPostErrors: [],
            postLink: '',
            errorNeedHelpOther: false,
            timeoutAirport: null,
            timeoutAirlines: null,
            loadingFields: {
                airport: false,
                airlines: false
            },
            currentLang: window.immiLang?.currentLangCode || 'en',
            pauseSubmit: window.immiObj.pauseAction
        }
    },
    created () {
        this.needHelpWith.forEach(item =>{
            this.selectedNeedHelp[item.needHelpWithId] = false;
        });

        if (immiObj.travelCompBean) {
            if (immiObj.travelCompBean.language1) this.languages.push(immiObj.travelCompBean.language1);
            if (immiObj.travelCompBean.language2) this.languages.push(immiObj.travelCompBean.language2);
            if (immiObj.travelCompBean.language3) this.languages.push(immiObj.travelCompBean.language3);
            if (immiObj.travelCompBean.language4) this.languages.push(immiObj.travelCompBean.language4);
        }

        /**
         * See if session has the variable to open add Exp block.
         * If the session key is available then open and delete the key.
         */
        if (isUserLoggedIn.isLoggedIn) {
            const isAddExpOpen = getItemSessionStorage(SessionKeys.experience.openTravelCompanion);
            if (isAddExpOpen) {
                this.openAddPost();
                deleteSessionStore(SessionKeys.experience.openTravelCompanion);
            }
        }
    },
    validations() {
        var validations = {...addTCvalidation};
        const self = this;

        if(this.addTCform.ticketBooked === 'No') {
            validations.addTCform.toTravelDate.dateNotBeforeCreatedDate = dateNotBeforeCreatedDate;

        } else {
            delete validations.addTCform.toTravelDate.dateNotBeforeCreatedDate;
        }

        function dateNotBeforeCreatedDate(val) {
            if (val) {
                if (val) {
                    var dateToCheck1 = new Date(convertoEnDate(val));
                    var created = new Date(convertoEnDate(self.addTCform.travelDate));

                    return created <= dateToCheck1;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        }
        
        return validations;
    },
    watch: {
        selectedNeedHelp() {
            this.updatedChecked();
        }
    },
    methods: {
        updatedChecked () {
            let isOtherSelected = false;
            let isOtherEmpty = false;
            this.addTCform.needHelpWithDTOs = [];
            for (let key in this.selectedNeedHelp) {
                if (this.selectedNeedHelp[key]) {
                    this.addTCform.needHelpWithDTOs.push({
                        needHelpWithId: key
                    });
                    // if other is chosen then other text box should have values
                }
            }
            if(this.selectedNeedHelp['8']) isOtherSelected = true;
            else this.addTCform.needHelpWithOther = "";
            if (isOtherSelected && (!this.addTCform.needHelpWithOther || !this.addTCform.needHelpWithOther.trim())) isOtherEmpty = true;
            this.errorNeedHelpOther = isOtherEmpty;
            this.$forceUpdate();
        },
        addTCSubmit () {
            this.$v.addTCform.$touch();
            this.isFormSubmitted = true;
            this.updatedChecked();
            if (!this.$v.addTCform.$invalid && !this.$v.languages.$invalid && !this.errorNeedHelpOther) {
                // Submit the form
                this.addLanguageToObj();
                this.addPostApiInProgress = true;
                if (this.addTCform.needHelpWithOther && this.addTCform.needHelpWithDTOs && this.addTCform.needHelpWithDTOs.length) {
                    for (let i = 0; i < this.addTCform.needHelpWithDTOs.length; i++) {
                        if (this.addTCform.needHelpWithDTOs[i].needHelpWithId == 8) {
                            this.addTCform.needHelpWithDTOs[i].otherValue = this.addTCform.needHelpWithOther;
                            break;
                        }
                    }
                }
                Vue.nextTick(()=>{
                    let params = JSON.parse(JSON.stringify(this.addTCform));
                    params.travelDate = params.travelDate == '' ? '' : convertoEnDate(this.addTCform.travelDate);
                    params.toTravelDate = params.toTravelDate == '' ? '' : convertoEnDate(this.addTCform.toTravelDate);
                    if (this.addTCform.itineraryLegDTOs && this.addTCform.itineraryLegDTOs.length) {
                        for(let i = 0; i < this.addTCform.itineraryLegDTOs.length; i++) {
                            params.itineraryLegDTOs[i].fromAirportId = params.itineraryLegDTOs[i].fromAirportId.airportId;
                            params.itineraryLegDTOs[i].toAirportId = params.itineraryLegDTOs[i].toAirportId.airportId;
                            params.itineraryLegDTOs[i].airlineId = params.itineraryLegDTOs[i].airlineId?.airlineId || null;
                            params.itineraryLegDTOs[i].itineraryOrder = i + 1;
                        }
                    }
                    this.addPostErrors = [];
                    this.$http.post(ApiUrls.travelCompanion.addPost, params).then((res) => {
                        this.addPostApiInProgress = false;
                        const response = res.body;
                        if(response.message === "error") {
                            this.addPostErrors = response.error;
                            Vue.nextTick(() => scrollToBlock('#add-post'));
                        } else {
                            this.addPostSuccess = true;
                            this.resetAdd();
                            this.postLink = response.link;
                            Vue.nextTick(() => scrollToBlock('#add-post'));
                        }
                    }, error => {
                        this.addPostApiInProgress = false;
                        const response = error?.body || null;
                        this.addPostErrors = response || 'Something went wrong please try again.';
                        Vue.nextTick(() => scrollToBlock('#add-post'));
                    })
                })
            } else {
                goToFirstError();
            }
        },
        addLanguageToObj () {
            let i = 1,
                langLen = this.languages?.length || 0;
            for (i; i <= langLen; i++) {
                this.addTCform['language' + i] = this.languages[i - 1];
            }
            const diff = 4 - langLen;
            if (diff) {
                i = 4;
                for (i; i > (4 - diff); i--) {
                    this.addTCform['language' + i] = -1;
                }
            }
        },
        resetAdd () {
            // this.addPost = false;
            this.languages = [];
            this.selectedNeedHelp = {};
            this.isFormSubmitted = false;            
            this.addTCform = {
                ...AddTravelCompanion
            };
            this.addTCform.itineraryLegDTOs = [{
                fromAirportId: '',
                toAirportId: '',
                airlineId: '',
                itineraryOrder: 1
            }]            
            this.$v.$reset();
        },
        addLeg () {
            const tcLegLenIndex = this.addTCform.itineraryLegDTOs && this.addTCform.itineraryLegDTOs.length ? (this.addTCform.itineraryLegDTOs.length - 1) : 0;
            if (tcLegLenIndex < 3) {
                const fromAirport = this.addTCform.itineraryLegDTOs[tcLegLenIndex]?.toAirportId || null;
                const airlines = fromAirport ? (this.addTCform.itineraryLegDTOs[tcLegLenIndex]?.airlineId || null) : null; 
                this.addTCform.itineraryLegDTOs.push({
                    fromAirportId: fromAirport,
                    toAirportId: '',
                    airlineId: airlines,
                    itineraryOrder: tcLegLenIndex + 1
                });
            }
        },
        deleteLeg(index) {
            this.addTCform.itineraryLegDTOs.splice(index, 1);
        },
        asyncAirport(text) {
            this.loadingFields.airport = true;
            if (this.timeoutAirport) clearTimeout(this.timeoutAirport);
            this.timeoutAirport = setTimeout(() => {
                this.debounceAirport(text);
            }, 450);
        },
        debounceAirport (text) {
            this.$http.post('/api/get-airports/',{query:text}).then(res=>{
                this.loadingFields.airport = false;
                const response = res.body;
                this.allAirports = response;
            }, error => {
                this.loadingFields.airport = false;
                console.log(error);
            });
        },
        asyncAirlines(text) {
            this.loadingFields.airlines = true;
            if (this.timeoutAirlines) clearTimeout(this.timeoutAirlines);
            this.timeoutAirlines = setTimeout(() => {
                this.debounceAirlines(text);
            }, 450);
        },
        debounceAirlines (text) {            
            this.$http.post('/api/get-airlines/', {query:text}).then(res => {
                const response = res.body;
                this.allAirlines = response;
                this.loadingFields.airlines = false;
            }, error => {
                this.loadingFields.airlines = false;
                console.log(error);
            });
        },
        openAddPost () {
            if (isUserLoggedIn.isLoggedIn) {
                this.addPost = true;
                Vue.nextTick(() => scrollToBlock('#add-post'));
            } else {
                setItemSessionStorage(SessionKeys.experience.openTravelCompanion, true);
                window.location.href = RedirectsUrls.login;
            }
        }
    }
};

export let AddTCvalidation = addTCvalidation;
export let AddTCdata = AddTravelCompanion;